import { useMutation } from "@tanstack/react-query";

import { requestEmailVerification } from "@/api";
import { useUIStore } from "stores/ui.store";

const useRequestEmailVerification = () => {
  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: () => {
      return requestEmailVerification();
    },
    onSuccess: () => {
      openToast({ variant: "info", message: "New code has been sent!" });
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useRequestEmailVerification };
